export default __webpack_public_path__ + "static/media/review_detail_3.8780851c.png";